import { clubDataRepository, globalDataRepository } from '../content/constants';
import type { BuildType } from '../enums/build/build-type';
import type { Language } from '../enums/language';

type CmsFileBase = {
  relativeDirectory: string;
};

export type CmsClubFileNode<T> = {
  childClubJson: T;
} & CmsFileBase;

export type CmsGlobalFileNode<T> = {
  childGlobalJson: T;
} & CmsFileBase;

export const parseAsPlatformCompatiblePath = (path: string): string => path.replace('\\', '/');

export const parseRelativeDirectory = (node: CmsFileBase) =>
  (node.relativeDirectory = parseAsPlatformCompatiblePath(node.relativeDirectory));

export const findCmsFileNodeForClub = <T extends CmsFileBase>(
  nodes: readonly T[],
  clubId: string,
  language: Language
): T | undefined => {
  return (
    nodes.find(
      (n) =>
        n.relativeDirectory === 'cross-club/club' || n.relativeDirectory === 'cross-club/promotions'
    ) ??
    nodes.find((n) => n.relativeDirectory === clubDataRepository(clubId, language)) ??
    nodes.find((n) => n.relativeDirectory === clubDataRepository(null, language))
  );
};

export const findCmsFileNodeForBrand = <T extends CmsFileBase>(
  nodes: readonly T[],
  language: Language,
  buildType: BuildType
): T | undefined => {
  return nodes.find((n) => n.relativeDirectory === globalDataRepository(language, buildType));
};
